import { useEffect, useRef } from 'react';

export function NavBar({ children }) {
  return <nav className="nav-bar">{children}</nav>;
}

export function Logo() {
  return (
    <div className="logo">
      <span role="img">🍿</span>
      <h1>usePopcorn</h1>
    </div>
  );
}

export function SearchBar({ query, setQuery }) {
  const inputElement = useRef(null);

  useEffect(() => {
    const callback = (e) => {
      // document.activeElement is the current focused element in the DOM
      if (document.activeElement === inputElement.current) return;

      if (e.code === 'Enter') {
        inputElement.current.focus();
        setQuery('');
      }
    };

    document.addEventListener('keydown', callback);

    return function () {
      document.removeEventListener('keydown', callback);
    };
  }, [setQuery]);

  return (
    <input
      className="search"
      type="text"
      placeholder="Search movies..."
      value={query}
      ref={inputElement}
      onChange={(e) => {
        setQuery(e.target.value);
      }}
    />
  );
}

export function SearchResultStats({ movies }) {
  return (
    <p className="num-results">
      Found <strong>{movies.length}</strong> results
    </p>
  );
}
